import { createBrowserRouter, RouteObject } from 'react-router';

import { BASE_PATH } from './';
import agencyRoutes from './routes/agencyRoutes';
import backofficeRoutes from './routes/backoffice-routes/backofficeRoutes';
import { clientRoutes } from './routes/clientRoutes';
import commonRoutes from './routes/commonRoutes';
import dcraInspectionRoutes from './routes/dcraInspectionRoutes';
import { elevatorsRoutes } from './routes/elevatorsRoutes';
import inspectorRoutes from './routes/inspectorRoutes';

const routes: RouteObject[] = [
  ...agencyRoutes,
  ...clientRoutes,
  ...elevatorsRoutes,
  ...dcraInspectionRoutes,
  // DCRA Inspectors
  ...inspectorRoutes,
  ...backofficeRoutes,
  ...commonRoutes,
];

export const router = createBrowserRouter(routes, {
  basename: BASE_PATH,
});
